<app-context-menu [options]="{ openOnHover: true }" [disabled]="(totalWatcherCount$ | async) === 0" #watcherMenu>
  <div contextButton>
    <ng-content></ng-content>
  </div>

  <div contextContent class="watcher-details">
    @if (watcherMenu.isOpen) {
      @let assetWatchers = assetWatchers$ | async;
      @let galleryWatchers = galleryWatchers$ | async;

      @if (!assetWatchers || !galleryWatchers) {
        <app-loading-indicator size="small"></app-loading-indicator>
      } @else {
        @if (assetWatchers.length) {
          @if (isTeamMember() && accessLevel() === 'edit') {
            <h3>Asset Subscribers</h3>
          }

          @for (watcher of assetWatchers; track watcher.id) {
            <div class="watcher-row-item">
              <div class="avatar">
                <app-avatar [user]="watcher"></app-avatar>
              </div>
              <div class="watcher-details">
                <div class="name">
                  {{ watcher.first_name }} {{ watcher.last_name }}
                  @if (watcher.id === myId) {
                    <span> (You)</span>
                  }
                </div>
                <div class="email">{{ watcher['email'] }}</div>
              </div>

              @if (isTeamMember() && accessLevel() === 'edit') {
                <button
                  appButton
                  name="remove-watcher"
                  location="new-comment-thread"
                  [iconButton]="true"
                  color="simple-gray"
                  shape="round"
                  height="-1"
                  appTooltip="Remove Asset Subscriber"
                  (click)="deleteWatcher(watcher)"
                >
                  <app-svg src="/assets/icons/cross.svg"></app-svg>
                </button>
              }
            </div>
          }
        }

        @if (assetWatchers.length && galleryWatchers.length && isTeamMember() && accessLevel() === 'edit') {
          <div class="divider"></div>
        }

        @if (galleryWatchers.length) {
          @if (isTeamMember() && accessLevel() === 'edit') {
            <h3>Gallery Subscribers</h3>
          }

          @for (watcher of galleryWatchers; track watcher.id) {
            <div class="watcher-row-item">
              <div class="avatar">
                <app-avatar [user]="watcher"></app-avatar>
              </div>
              <div class="watcher-details">
                <div class="name">
                  {{ watcher.first_name }} {{ watcher.last_name }}
                  @if (watcher.id === myId) {
                    <span> (You)</span>
                  }
                </div>
                <div class="email">{{ watcher['email'] }}</div>
              </div>
              @if (isTeamMember() && accessLevel() === 'edit') {
                <button
                  appButton
                  name="open-gallery-subscribers-dialog"
                  location="new-comment-thread"
                  [iconButton]="true"
                  color="simple-gray"
                  shape="round"
                  height="-1"
                  appTooltip="View Gallery Subscribers"
                  (click)="openGallerySubscribersDialog()"
                >
                  <app-svg src="/assets/icons/external-link.svg"></app-svg>
                </button>
              }
            </div>
          }
        }
      }
    }
  </div>
</app-context-menu>
